import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const ServiceOffert = lazy(() => import("@/pages/offert/ServiceOffert"));

export const Route = createFileRoute("/varmepumpar/offert")({
  head: () => seoHead("/varmepumpar/offert"),
  component: () => <ServiceOffert service="varmepumpar" />,
});
